
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component<Loading>({})
export default class Loading extends Vue {
    @Prop({ type: String, default: 'spinner' }) public type!: String
    @Prop({ type: Boolean, default: false }) public loading!: boolean
    @Prop({ type: Boolean, default: false }) public contained!: boolean
    @Prop({ type: Boolean, default: false }) public inline!: boolean
    @Prop({ type: Boolean, default: false }) public transparent!: boolean

    get containerClass() {
        switch (this.type) {
            case 'dots':
                return null
            case 'spinner':
            default:
                return {
                    loading: this.loading,
                    'not-loading': !this.loading,
                    contained: this.contained,
                    inline: this.inline,
                    transparent: this.transparent,
                }
        }
    }
}
